var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ChatbotWelcome"},[_c('el-avatar',{staticClass:"chat-avatar",attrs:{"src":_vm.chatHead}}),_c('div',{staticClass:"ChatbotWelcome-content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1),_c('div',{staticClass:"clear-float"})])
}
var staticRenderFns = []

export { render, staticRenderFns }